import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ISupplierInvoice } from '../interfaces/supplier-invoice';
import { ISupplierInvoiceFilter } from '../interfaces/supplier-invoice-filter';
import { ISupplierPaymentFilter } from '../interfaces/supplier-payment-filter';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class SupplierInvoiceService extends ReadService<ISupplierInvoice, ISupplierInvoiceFilter> {
  url = '/api/supplierinvoices';
  entityTitle = 'Supplier invoice';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getSupplierInvoicePayments(invoiceId: number, filter: ISupplierPaymentFilter): Promise<any> {
    let params = this.constructHttpParams(filter);
    return this.handleRequest(
      this.http.get<any[]>(`${this.url}/getSupplierInvoicePayments?invoiceId=${invoiceId}`, {
        params: params,
      }),
      this.handlersFactory.getForReadAll(),
    ).then(this.extractData);
  }

  getSupplierInvoiceReport(filter: ISupplierInvoiceFilter): Promise<any> {
    let params = this.constructHttpParams(filter);
    return this.handleRequest(
      this.http.get<any[]>(`${this.url}/getSupplierInvoiceReport`, { params: params }),
      this.handlersFactory.getForReadAll(),
    ).then(this.extractData);
  }

  cancelInvoice(id: number, reason: string): Promise<any> {
    return this.http
      .get(`${this.url}/cancelInvoice?id=${id}&reason=${reason}`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  uncancelInvoice(id: number): Promise<any> {
    return this.http
      .get(`${this.url}/uncancelInvoice?id=${id}`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  updateSupplierInvoice(data: any): Promise<any> {
    return this.http
      .post<any>(`${this.url}/updateSupplierInvoice`, data)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  getEngineiusDetailsForInvoice(): Promise<any> {
    return this.http
      .get(`${this.url}/getEngineiusDetailsForInvoice`)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }

  createInvoicesForTransactions(transactionLineIds: any[]): Promise<any> {
    return this.http
      .post<any[]>(`${this.url}/createInvoicesForTransactions`, transactionLineIds)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
}

export enum SupplierInvoiceProcessingType {
  batch = 1,
  failed = 2,
  cancelled = 3,
  invoices = 4,
  unbatched = 5,
}

export function SupplierInvoiceProcessingTypeEnumAware(constructor: Function) {
  constructor.prototype.SupplierInvoiceProcessingType = SupplierInvoiceProcessingType;
}
